// extracted by mini-css-extract-plugin
module.exports = {"form":"ChangePassword_form__1WnjJ","inputs":"ChangePassword_inputs__2ywJ0","error":"ChangePassword_error__2yruN"};